export function translate(obj, props, lang) {
  return obj[props + lang.toUpperCase()]
}
